import React, { useContext, useState, useEffect } from 'react'
import { MyContext } from '../../Context/MyProvider'
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const Faq = () => {

    const { BaseUrl } = useContext(MyContext);

    const [faqlist, setFaqlist] = useState([]);
    const [expandedIndex, setExpandedIndex] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const uid = secureLocalStorage.getItem("Userid") || "0";
        axios.post(`${BaseUrl}/eapi/e_faq.php`, { uid })
            .then((res) => {
                // console.log("e_faq.php", res.data);
                setFaqlist(res.data.FaqData);
                setLoading(false);
            })
            .catch((error) => {
                console.error("e_faq.php", error);
            });
    }, []);

    const handleChange = (index) => {
        const Index = expandedIndex === index ? "" : index;
        setExpandedIndex(Index);
    };

    return (
        <div className='faq_page'>
            {loading
                ? <div className="w-full h-[calc(100vh-90px)] bg-white z-[777] fixed flex items-center justify-center">
                    <div className="loader"></div>
                </div>
                : <div className="width_container">
                    <div className="mt-[20px]">
                        <h1 className="title">Faq's</h1>
                        {faqlist?.map((item, index) => {
                            const isOpen = expandedIndex === index;
                            return (
                                <div key={index} className="mb-[8px]">
                                    <Accordion style={{
                                        borderRadius: "20px", padding: "10px 0", boxShadow: "none"
                                    }} expanded={isOpen} onChange={() => handleChange(index)} className='border' >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls={`panel${index}-content`}
                                            id={`panel${index}-header`}
                                        >
                                            <Typography className='max-_430_:text-[14px]' component="span">{item.question}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className='max-_430_:text-[14px]'>{item.answer}</AccordionDetails>
                                    </Accordion>
                                </div>
                            );
                        })}
                    </div>
                </div>}
        </div >
    )
}

export default Faq